<app-data-table-manager
  [columnConfigs]="columnConfigs"
  [filterConfig]="DEFAULT_FILTER_CONFIG"
  [tableName]="'listRecipes'"
  [tableData]="tableData"
  [displayInfo]="displayInfo"
  (loadDataRequested)="loadData($any($event))"
>
</app-data-table-manager>
